require("../../libs/backbone/backbone.ajaxq.adapter.ts");
var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/patient.template.htm');
require('dhtmlxMessage');
var Model = require('../models/patients.model.ts');
// var QueuesOptions = require("views/queues_options.view.ts");
var QueuesOptions = require("views/kiosks_queues_options.view.ts");
var i18n = require('l10n');
var PatientsCollection = require('../models/patients.collection.ts');

var TheView = GenericView.extend({
    el: "#container",
    tagName: 'div',
	template: Handlebars.compile(Template),
	superInitialize: GenericView.prototype.initialize,
	model : null,
	id: null,
    editable: null,
    fields: null,
    userData: null,
    privilegeLevel: null,
    back: false,
    patientsCollection: null,
	initialize: function (options) {
	    var self = this;
	    this.id = options ? options.id : null;
        this.userData = options.data;
        this.privilegeLevel = this.privilegeLevelToNumber(this.userData.privilegeLevel);
        this.patientsCollection = new PatientsCollection();
        this.listenTo(this.patientsCollection, "addPaymentSuccess", this.addPaymentResponse);
        if(this.id) {
            this.editable = true;
            this.model = new Model({ id : this.id });
            this.model.fetch({
                success: function(response)
                {
                    self.render();
                },
                error: function(response, xhr, status)
                {

                }
            });
        } else {
            this.editable = false;
            this.model = new Model();
            this.render();
        }

        this.fields =
        {
            firstName: [this.isEmpty],
            lastName: [this.isEmpty],
            phoneNumber: [this.isEmpty]
        }
	},
	superRender: GenericView.prototype.render,
	render: function () {  
        this.superRender();
		var self = this;

		var data = $.extend(this.model.toJSON(), { editable: this.editable, queueType: 'queuesExaminations' });

        this.$el.html(this.template(data));

        this.queuesOptions = new QueuesOptions(data);

	},
	events: {
        "click #submitBack": "clickOnSubmitBack",
        // "click #addNewPayment": "addNewPayment",
        "click #reset": "clickOnReset",
        "click #cancel": "onCancel",
        "change .to-validation input": "validateIt",
        "keyup .to-validation input": "validateIt",
        "focusout .to-validation input": "validateIt",
        "change .standardSelect": "validateSelectField"
	},
    onCancel: function()
    {
       this.goBack();
    },
	clickOnReset: function(e)
    {
        $("#firstName").find("input").val("");
        $("#lastName").find("input").val("");
        $("#phoneNumber").find("input").val("");
        // this.queuesOptions.clearView();
    },
    // addNewPayment: function() {

    //     var selectedQueues = this.getSelectedQueues() !== undefined ? this.getSelectedQueues() : [];

    //     var data = {
    //         firstName: $("#firstName").find("input").val().trim(),
    //         lastName: $("#lastName").find("input").val().trim(),
    //         phoneNumber: $("#phoneNumber").find("input").val().trim(),
    //         queueIds: selectedQueues
    //     };

    //     this.patientsCollection.add(data);

    //     console.log('Item added to collection:', data);

    //     this.clickOnReset();
    // },
	clickOnSubmitBack: function(e)
    {
       this.back = true;
        this.clickOnSubmit(null);

    },
	clickOnSubmit: function(e)
    {
        var self = this;

        var fields = {
            firstName: [this.isEmpty],
            lastName: [this.isEmpty],
            phoneNumber: [this.isEmpty]
        };

        var selectedQueues = this.getSelectedQueues() !== undefined ? this.getSelectedQueues() : [];

        var has_error = this.validateFields(fields);
        
        if(selectedQueues.length === 0) {
            has_error = true;
            this.$el.find('#kQueuesOptions .chosen-choices').addClass("has-error");
            self.setError($("#kQueuesOptions"), i18n.t("account.empty_field"));
        }

        if(!has_error)
        {

            var data = {
                firstName: $("#firstName").find("input").val().trim(),
                lastName: $("#lastName").find("input").val().trim(),
                phoneNumber: $("#phoneNumber").find("input").val().trim(),
                queueIds: selectedQueues
            };

            if(this.editable === true) {
                
                this.model.set("firstName", data.firstName);
                this.model.set("lastName", data.lastName);
                this.model.set("phoneNumber", data.phoneNumber);
                this.model.set("queueIds", selectedQueues);
    
                this.model.save(null, {
                    success: function(response) {
                        self.hideActionProgressBar();
                            $.notify(i18n.t("patients.patient_updated"), { position:"top center", className: "success" });
    
                            if(self.back)
                                self.goBack();
                            self.back = false;
                    },
                    error: function(model, response) {
                        var responseJSON = response.responseJSON || {};
                        
                        if (response.status == 409) {
                            self.hideActionProgressBar();
                            $.notify(i18n.t("patients.error_patient_exists"), { position: "top center", className: "error" });
                        }
                    }
                });
            } else {

                this.patientsCollection.add(data);
                this.showActionProgressBar();
                this.patientsCollection.save();
                this.patientsCollection.reset();
            }
        }
        else {
            this.hideActionProgressBar();
            $.notify(
                i18n.t("account.check_errors"),
                { position:"top center", className: "error" }
            );
        }

    },
    validateIt: function(event)
    {
        if(event.which > 36 && event.which < 41)
            return;

        var element = $(event.currentTarget).parent();
        var field = {};
        field[element.prop("id")] = this.fields[element.prop("id")]

        var has_error = this.validateFields( field );
    },
    validateSelectField: function(event)
    {
        var self = this;
        var selectedQueues = this.getSelectedQueues() !== undefined ? this.getSelectedQueues() : [];

        if(selectedQueues.length === 0) {
            this.$el.find('#kQueuesOptions .chosen-choices').addClass("has-error");
            self.setError($("#kQueuesOptions"), i18n.t("account.empty_field"));
        } else {
            this.$el.find('#kQueuesOptions .chosen-choices').removeClass("has-error");
            self.clearError($("#kQueuesOptions"));
        }
    },
    getSelectedQueues: function() {
        var queuesIdsArray = [];
        var queuesName = [];

        this.$el.find('#kQueuesOptions .chosen-choices .search-choice').each(function() {
            var option = $(this).find('span').text();
            var match = option.match(/^\d+(?= -)/);

            if (match) {
                var queueId = parseInt(match[0], 10);
                queuesIdsArray.push(queueId);
            }
        });

        return queuesIdsArray;
    },
    addPaymentResponse: function(successOrError, response) {
        var self = this;

        if(successOrError === 'success') {
            //Hide the generic progress bar
            self.hideActionProgressBar();
            if (self.editable) {
                $.notify(i18n.t("patients.patient_updated"), { position: "top center", className: "success" });
                
                if (self.back)
                    self.goBack();
                    self.back = false;
                }
            else {
                $.notify(i18n.t("patients.patient_added"), { position: "top center", className: "success" });
                self.goBack();
            }
        } else if(successOrError === 'error') {
            if (response.status == 409) {
                self.hideActionProgressBar();
                $.notify(i18n.t("patients.error_patient_exists"), { position: "top center", className: "error" });
            }
        }
    }
});

module.exports = TheView;